import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./index.css";
import Axios from "axios";
import { CircularProgress } from "@mui/material";
import { ArrowLeft } from "@mui/icons-material";
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid,
//   Tooltip, Legend, ResponsiveContainer,
// } from "recharts";

const statCardAccents = ["#6366f1", "#f59e0b", "#10b981", "#3b82f6"];

const SummaryCard = ({ title, value, sub1Label, sub1Value, sub1Color, sub2Label, sub2Value, sub2Color }) => (
  <div style={{
    background: "#111827",
    borderRadius: 12,
    padding: "24px 28px",
    flex: 1,
    minWidth: 220,
  }}>
    <p style={{ margin: "0 0 10px", fontFamily: "Nunito", fontWeight: 700, fontSize: 11, color: "#6b7280", textTransform: "uppercase", letterSpacing: 1.2 }}>
      {title}
    </p>
    <p style={{ margin: "0 0 16px", fontFamily: "Nunito", fontWeight: 800, fontSize: 42, color: "#ffffff", lineHeight: 1 }}>
      {value}
    </p>
    <div style={{ display: "flex", gap: 28, borderTop: "1px solid #1f2937", paddingTop: 14 }}>
      <div>
        <p style={{ margin: 0, fontFamily: "Nunito", fontSize: 11, color: "#6b7280", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.8 }}>{sub1Label}</p>
        <p style={{ margin: "3px 0 0", fontFamily: "Nunito", fontSize: 20, color: sub1Color, fontWeight: 800 }}>{sub1Value}</p>
      </div>
      <div>
        <p style={{ margin: 0, fontFamily: "Nunito", fontSize: 11, color: "#6b7280", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.8 }}>{sub2Label}</p>
        <p style={{ margin: "3px 0 0", fontFamily: "Nunito", fontSize: 20, color: sub2Color, fontWeight: 800 }}>{sub2Value}</p>
      </div>
    </div>
  </div>
);

const StatCard = ({ title, data, accent }) => (
  <div style={{
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    borderTop: `4px solid ${accent}`,
    padding: "20px 24px",
    flex: 1,
  }}>
    <p style={{ margin: "0 0 16px", fontFamily: "Nunito", fontWeight: 700, fontSize: 13, color: "#6b7280", textTransform: "uppercase", letterSpacing: 1 }}>
      {title}
    </p>
    <p style={{ margin: "0 0 12px", fontFamily: "Nunito", fontWeight: 800, fontSize: 36, color: "#111827", lineHeight: 1 }}>
      {data.total}
    </p>
    <div style={{ display: "flex", flexDirection: "column", gap: 8, borderTop: "1px solid #f3f4f6", paddingTop: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontFamily: "Nunito", fontSize: 13, color: "#6b7280", fontWeight: 600 }}>Verified</span>
        <span style={{ fontFamily: "Nunito", fontSize: 15, fontWeight: 700, color: "#10b981" }}>{data.verified}</span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontFamily: "Nunito", fontSize: 13, color: "#6b7280", fontWeight: 600 }}>Pending</span>
        <span style={{ fontFamily: "Nunito", fontSize: 15, fontWeight: 700, color: "#ef4444" }}>{data.nonverified}</span>
      </div>
    </div>
  </div>
);

const ActionBtn = ({ label, onClick }) => (
  <button
    onClick={onClick}
    style={{
      background: "#111827",
      color: "#ffffff",
      border: "none",
      borderRadius: 8,
      padding: "10px 20px",
      fontFamily: "Nunito",
      fontSize: 13,
      fontWeight: 700,
      cursor: "pointer",
      transition: "background 0.15s",
      whiteSpace: "nowrap",
    }}
    onMouseEnter={e => (e.currentTarget.style.background = "#374151")}
    onMouseLeave={e => (e.currentTarget.style.background = "#111827")}
  >
    {label}
  </button>
);



const AdminDashboard = () => {
  const history = useNavigate();
  const [startup, setStartup] = useState();
  const [investors, setInvestors] = useState();
  const [fundCompanies, setfundCompanies] = useState();
  const [corporates, setcorporates] = useState();
  const [twbalance, settwbalance] = useState();

  // Revenue state
  // const [revenueYear, setRevenueYear] = useState(CUR_YEAR);
  // const [revenueTotal, setRevenueTotal] = useState(null);
  // const [revenueActual, setRevenueActual] = useState(null);
  // const [revenueSubscriptions, setRevenueSubscriptions] = useState(null);
  // const [revenueMonthly, setRevenueMonthly] = useState([]);
  // const [revenueLoading, setRevenueLoading] = useState(true);

  const fetchStats = async () => {
    const { data } = await Axios({ method: "get", url: "/api/admin/stats" });
    const { Investors, Startups, FundCompanies, Corporates } = data;
    setStartup(Startups);
    setInvestors(Investors);
    setfundCompanies(FundCompanies);
    setcorporates(Corporates);
  };

  const fetchTwilio = async () => {
    const { data } = await Axios({ method: "get", url: "/api/admin/twilio-balance" });
    settwbalance(data.balance);
  };

  useEffect(() => {
    fetchStats();
    fetchTwilio();
  }, []);



  if (!startup || !investors || !corporates || !fundCompanies || !twbalance) {
    return (
      <div className="v_center">
        <CircularProgress />
        <Link to="/">
          <button className="gradient_admin_btn m-4 ms-5">
            <ArrowLeft />
            Back to Login
          </button>
        </Link>
      </div>
    );
  }

  return (
    <div style={{ padding: "36px 40px", maxWidth: 1200, boxSizing: "border-box" }}>

      {/* Row 1: Title + Twilio balance */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 32 }}>
        <h1 style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 40, color: "#111827", margin: 0, lineHeight: 1.1 }}>
          Dashboard
        </h1>
        <div style={{
          background: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: 12,
          padding: "14px 24px",
          textAlign: "right",
          minWidth: 160,
        }}>
          <p style={{ margin: 0, fontFamily: "Nunito", fontSize: 11, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: 1 }}>
            Twilio Balance
          </p>
          <p style={{ margin: "4px 0 0", fontFamily: "Nunito", fontSize: 26, fontWeight: 800, color: "#111827" }}>
            {twbalance}
          </p>
        </div>
      </div>

      {/* Row 2: Action buttons */}
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 40 }}>
        <ActionBtn label="Onboard Corporate"    onClick={() => history("/admin/corporate")} />
        <ActionBtn label="Onboard Fund Company" onClick={() => history("/admin/funds")} />
      </div>

    

      {/* Row 4: Summary blocks */}
      {(() => {
        const totalUsers    = startup.total    + investors.total    + fundCompanies.total    + corporates.total;
        const totalVerified = startup.verified + investors.verified + fundCompanies.verified + corporates.verified;
        const totalPending  = startup.nonverified + investors.nonverified + fundCompanies.nonverified + corporates.nonverified;
        const rate = totalUsers ? Math.round((totalVerified / totalUsers) * 100) : 0;
        return (
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 32 }}>
            <SummaryCard
              title="Total Users"
              value={totalUsers}
              sub1Label="Verified"   sub1Value={totalVerified} sub1Color="#10b981"
              sub2Label="Pending"    sub2Value={totalPending}  sub2Color="#ef4444"
            />
            <SummaryCard
              title="Total Verified Users"
              value={totalVerified}
              sub1Label="Rate"       sub1Value={`${rate}%`}    sub1Color="#60a5fa"
              sub2Label="Unverified" sub2Value={totalPending}  sub2Color="#f87171"
            />
          </div>
        );
      })()}

      {/* Row 4: Statistics by type */}
      <div>
        <p style={{ fontFamily: "Nunito", fontWeight: 700, fontSize: 11, color: "#9ca3af", textTransform: "uppercase", letterSpacing: 1.5, margin: "0 0 16px" }}>
          By Type
        </p>
        <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          <StatCard title="Startups"       data={startup}       accent={statCardAccents[0]} />
          <StatCard title="Investors"      data={investors}     accent={statCardAccents[1]} />
          <StatCard title="Fund Companies" data={fundCompanies} accent={statCardAccents[2]} />
          <StatCard title="Corporates"     data={corporates}    accent={statCardAccents[3]} />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
